// extracted by mini-css-extract-plugin
export default {"loginPage":"signIn_loginPage__8xaKd"};